/* eslint-disable @typescript-eslint/ban-ts-comment */
import { request } from '@remote/api/request'
import { USER_RUNNER } from '@remote/constant'
import { isInXunleiApp, isInPCXunlei } from '@remote/utils'
import type { ITaskRes, IErrorRes } from '@remote/type'
import { IRequestInterceptorParams } from '@remote/api/adapter/index.d'

const formatHeziDeviceDataToNasDeviceData = (devices?: ITaskRes['tasks']) => {
  return devices ? devices.map(item => {
    return {
      ...item,
      params: {
        ...item.params,
        device_config: '{"device_space":"","speed_limit":-1,"runner_count":5,"download_paths":["内置磁盘/我的下载"],"file_mount":{},"single_task_max_mb":100,"single_task_reserve_mb":20,"overall_share_max_mb":200}',
        device_model: 'xlbox',
        downloads: '[{"name":"","path":"内置磁盘/我的下载","usage":94436356096,"limit":201004470272,"errmsg":"","is_root_path":true}]',
      },
    }
  }) : []
}

const getHeziDeviceList = async (userid: number): Promise<[IErrorRes, ITaskRes | null]> => {
  const url = '/drive/v1/tasks'
  const params = { platform: 'pc', userid: userid, t: 10086 || Date.now() }
  return request(url, params, { apiEnv: 'heziProduction' })
}

interface IGetDeviceListParams {
  userid: number
  space?: string
  limit?: number
  filters?: string
}

// const randomData = () => {
//   const task = {
//     "tasks": [{
//       "kind": "drive#task",
//       "id": "891c168fc54c6c746ccf947c5832a6d8",
//       "name": "盒子设备",
//       "type": "user#runner",
//       "user_id": "284819474",
//       "params": {
//         "ip": "100.127.194.151",
//         "lan_ip": "192.168.99.20",
//         "platform": "xlbox",
//         "target": "891c168fc54c6c746ccf947c5832a6d8"
//       },
//       "phase": Math.random() > 0.5 ? "PHASE_TYPE_OFFLINE" : "PHASE_TYPE_RUNNING",
//       "created_time": "2022-09-05T21:15:33+08:00",
//       "updated_time": "2023-04-21T11:05:47+08:00"
//     }]
//   }
//   const error = {
//     "code": -1,
//     "error": "failed_precondition",
//     "error_code": -1,
//     "error_description": "接口请求错误",
//     "msg": "接口请求错误"
//   }
//   return Math.random() > 0.5 ? [null, task] : [error, null]
// }
const getDeviceList = async (params: IGetDeviceListParams): Promise<[IErrorRes | null, ITaskRes | null]> => {
  const { space, userid } = params
  // 非pc迅雷、手雷不展示其他nas设备
  const isOnlyShowHezi = !(isInXunleiApp() || isInPCXunlei() || location.search.includes('space='))
  const [heziError, heziRes] =await getHeziDeviceList(userid!)
  // @ts-ignore
  const heziDeviceList = formatHeziDeviceDataToNasDeviceData(heziRes?.tasks) as ITaskRes['tasks']

  if (isOnlyShowHezi) {
    if (heziError || !heziRes) {
      return [heziError, null]
    }

    return [
      heziError,
      {
        expires_in: 60,
        next_page_token: '',
        tasks: heziDeviceList,
      } as ITaskRes,
    ]
  }

  const [err, res]: [IErrorRes, ITaskRes] = await request('/drive/v1/tasks', {
    type: USER_RUNNER,
    space: space,
    filters: params.filters,
  }, {
    apiEnv: 'production',
  }).catch(err => {
    console.error('request nas device error')
    return [err, []]
  })

  if (heziDeviceList?.length) {
    // @ts-ignore
    return res?.tasks ? [null, { ...res, tasks: [...heziDeviceList, ...res.tasks] }] : [
      heziError,
      {
        expires_in: 60,
        next_page_token: '',
        tasks: heziDeviceList,
      } as ITaskRes,
    ]
  } else {
    return [err, res]
  }
}

export function interceptGetDeviceList ({ config, response }: { config: IRequestInterceptorParams; response: unknown }) {
  const getDeviceListApiUrl = 'get/device/list'
  if (config.url.includes(getDeviceListApiUrl)) {
    return { config, response: getDeviceList(config.params as IGetDeviceListParams) }
  }
  return { config, response }
}